import { SelectFieldProps } from "@fanduel/formation-react-components";
import {
  DATE_ASC,
  DATE_DESC,
  TOTAL_DESC,
  TOTAL_ASC,
  SPREAD_DESC,
  SPREAD_ASC,
  MARGIN_DESC,
  MARGIN_ASC,
} from "@/constants/schedule";

export const weekOptions: NonNullable<SelectFieldProps["options"]> = [
  { label: "Week 1", value: "1" },
  { label: "Week 2", value: "2" },
  { label: "Week 3", value: "3" },
  { label: "Week 4", value: "4" },
  { label: "Week 5", value: "5" },
  { label: "Week 6", value: "6" },
  { label: "Week 7", value: "7" },
  { label: "Week 8", value: "8" },
  { label: "Week 9", value: "9" },
  { label: "Week 10", value: "10" },
  { label: "Week 11", value: "11" },
  { label: "Week 12", value: "12" },
  { label: "Week 13", value: "13" },
  { label: "Week 14", value: "14" },
  { label: "Week 15", value: "15" },
  { label: "Week 16", value: "16" },
  { label: "Week 17", value: "17" },
  { label: "Week 18", value: "18" },
];

export const playoffWeeksGroup = [
  {
    label: "Playoffs",
    options: [
      { label: "Wildcard", value: "19" },
      { label: "Division", value: "20" },
      { label: "Conference", value: "21" },
      { label: "Super Bowl", value: "22" },
    ],
  },
];

export const teamFilterOptions = [
  { label: "All Teams", value: "all" },
  { label: "AFC", value: "AFC" },
  { label: "NFC", value: "NFC" },
];

export const sortOptions = [
  { label: "Date (Earliest)", value: DATE_ASC },

  { label: "Date (Latest)", value: DATE_DESC },

  { label: "Total Line (Highest)", value: TOTAL_DESC },

  { label: "Total Line (Lowest)", value: TOTAL_ASC },

  { label: "Spread (Biggest Margin)", value: SPREAD_DESC },

  { label: "Spread (Smallest Margin)", value: SPREAD_ASC },

  { label: "nF Projection (Biggest Margin)", value: MARGIN_DESC },

  { label: "nF Projection (Smallest Margin)", value: MARGIN_ASC },
];
